import { isAnchorLink } from '@sola/utils/url.ts';

export const handleAnchorClick = (e: React.MouseEvent, href: string) => {
  if (isAnchorLink(href)) {
    e.preventDefault();
    const targetId = href.replace('#', '');
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      const header = document.getElementsByClassName(
        'Header',
      )[0] as HTMLElement;
      const headerHeight = header ? header.offsetHeight : 0;
      const elementPosition = targetElement.offsetTop - headerHeight;
      // @TODO: Temp fix.Remove this once we implement a component for SAC Sidekick.
      if (targetId === 'add-cdsp') {
        targetElement.click();
        window.scrollTo({
          top: 0,
          behavior: 'instant',
        });
      } else {
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth',
        });
        window?.history.pushState(null, '', href);
      }
    }
  }
};
